export const ADD_EMPLOYEE_GUIDELINES_NEW_INVITE_TEST_ID = 'add-employee-guidelines-new-invite-test-id';
export const ADD_EMPLOYEE_GUIDELINES_USER_IN_SYSTEM_TEST_ID = 'add-employee-guidelines-user-in-system-test-id';
